import { useState } from "react";
import { useTranslation } from "react-i18next";
import {
  Box,
  Typography,
  Tabs,
  Tab,
  Paper,
} from "@mui/material";
import BulkGifts from "./BulkGifts";
import BulkDiamondPoints from "./BulkDiamondPoints";
import BirthdayGift from "./BirthdayGift";
import RegistrationGift from "./RegistrationGift";
import { canShowPermission } from "../Permissions/permissionObject";
import { useEffect } from "react";
import InfoButton from "../../Comman/InfoButton";

export default function GiftsPage() {
  const { t } = useTranslation();
  const [tabIndex, setTabIndex] = useState(0);

  const handleTabChange = (event, newValue) => {
    setTabIndex(newValue);
  };

  const [permissions, setPermissions] = useState({});

  useEffect(() => {
    const storedPermissions = localStorage.getItem("userPermissions");
    if (storedPermissions) {
      setPermissions(JSON.parse(storedPermissions));
    }
  }, []);

  const canViewBulkGifts = canShowPermission(permissions, "bulkGifts", "view");
  const canViewBulkDiamondPoints = canShowPermission(permissions, "bulkDiamondPoints", "view");
  const canViewBirthdayGift = canShowPermission(permissions, "birthdayGift", "view");
  const canViewRegistrationGift = canShowPermission(permissions, "registrationGift", "view");

  const tabs = [
    canViewBulkGifts && {
      label: t("tabs.bulkGifts"),
      content: <BulkGifts />
    },
    canViewBulkDiamondPoints && {
      label: t("tabs.bulkDiamondPoints"),
      content: <BulkDiamondPoints />
    },
    canViewBirthdayGift && {
      label: t("tabs.birthdayGift"),
      content: <BirthdayGift />
    },
    canViewRegistrationGift && {
      label: t("tabs.registrationGift"),
      content: <RegistrationGift />
    }
  ]
  .filter(Boolean);

  return (
    <Box sx={{ width: "100%", height: "100vh", overflow: "auto" }}>
      <Box sx={{ position: "relative" }}>
      <Box
        sx={{
          width: "100%",
          mt: { xs: 10, md: 10 },
          background: "#fff",
          borderRadius: "16px",
          boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
        }}
      >
        <Paper
          sx={{ p: { xs: 2, sm: 4 }, mb: 2, borderRadius: "16px" }}
          elevation={1}
        >
          <Tabs
            value={tabIndex}
            onChange={handleTabChange}
            textColor="primary"
            indicatorColor="primary"
            variant="fullWidth"
            sx={{
              mb: 0,
              backgroundColor: "#f5f5f5",
              borderRadius: "8px",
              padding: "4px",
              "& .MuiTab-root": {
                fontWeight: 600,
                fontSize: "16px",
                textTransform: "none",
                borderRadius: "6px",
                margin: "0 4px",
                minHeight: "48px",
                "&.Mui-selected": {
                  backgroundColor: "#fff",
                  color: "#7A3FFF",
                  boxShadow: "0 2px 4px rgba(0,0,0,0.1)",
                  borderBottom: "3px solid #7A3FFF",
                },
                "&:hover": {
                  backgroundColor: "rgba(122, 63, 255, 0.08)",
                },
              },
              "& .MuiTabs-indicator": {
                display: "none",
              },
            }}
          >
            {tabs.map((tab, index) => (
              <Tab key={index} label={tab.label} />
            ))}
          </Tabs>
          <Box sx={{ mt: 0 }}>
            {tabs[tabIndex]?.content}
          </Box>
          
        </Paper>
      </Box>
      <Box
    sx={{
      position: "fixed",
      bottom: 24,
      right: 24,
      zIndex: 1000,
    }}
  >
    <InfoButton pageName="GIFT" />
  </Box>
      </Box>
    </Box>
  );
}

